import React from 'react';
import ProductView from "./productView";
import MaintenancePage from './maintenance_page';

const HomeModule = () => {
  return (
    <>
    <div className="relative w-full h-screen z-0">
    <div
      className="absolute inset-0 bg-cover bg-center bg-opacity-50 backdrop-blur-md shadow-lg bg-black"
      style={{
        backgroundImage: `url('https://i.ibb.co/m86VrCd/Component-86.png')`,
      }}
    />
     <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-white">
     <h1 className="text-4xl md:text-5xl font-bold mb-4 lg:text-6xl text-center">
       We’ll Be Back Soon!
      </h1>
      <p className="text-lg md:text-xl mb-8 text-[#E7E7E7] text-center">
      Our website is currently undergoing maintenance. Stay tuned!
      </p>
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center items-center">
        {/* Request Demo Button */}
        <div className="lg:flex relative items-center overflow-hidden rounded-full border-[2px] border-[#210543] p-[2px]">
          <div className="relative flex w-full rounded-full bg-white px-6 sm:px-8 py-2 sm:py-3 text-sm sm:text-base text-black justify-center">
          Contact Us
          </div>
        </div>
        {/* Get Started Button */}
        <div className="lg:flex relative items-center overflow-hidden rounded-full border-[2px] border-[#210543] p-[2px]">
          <div className="animate-rotate absolute inset-0 h-full w-full rounded-full bg-[conic-gradient(#FFFFFF_20deg,transparent_120deg)]"></div>
          <div className="relative flex w-full rounded-full bg-black px-6 sm:px-8 py-2 sm:py-3 text-sm sm:text-base text-white justify-center">
            Get Started
          </div>
        </div>
      </div>
      {/* <MaintenancePage /> */}
    </div> 
  </div>
  {/* <ProductView /> */}
  </>
  );
};

export default HomeModule;
